export default __webpack_public_path__ + "static/media/buzzImg.b1098d42.png";